<script lang='ts' setup>
import type { HTMLAttributes } from 'vue'
import type { PrimitiveProps } from 'reka-ui'

import { cn } from 'cn'
import { Primitive } from 'reka-ui'

interface Props extends PrimitiveProps {
  class?: HTMLAttributes['class']
}
const props = withDefaults(defineProps<Props>(), {
  as: 'div',
})
</script>

<template>
  <Primitive
    data-slot="message-content"
    :as
    :as-child
    :class="cn(
      'gap-2.5 group-data-[align=end]/message:[&>[data-slot]]:self-end flex w-full min-w-0 flex-col break-words',
      props.class,
    )"
  >
    <slot />
  </Primitive>
</template>
